<template>
  <div class="view">
    <Title title="イベント"/>
    <quizset-main />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import QuizsetMain from '@/components/Event/QuizsetMain'

export default {
  components: {
    Title,
    QuizsetMain
  }
}
</script>
